import { FlattenRoute } from '../types/navigation';

const getPathFromUrl = (url: string): string => {
	try {
		const urlObj = new URL(url);

		return urlObj.pathname.replace(/\/$/, '');
	} catch (e) {
		console.error(`Error during getting path from url, e: ${e}`);
		
		return url.replace(/\/$/, '');
	}
};

const findExactPathMatch = (routes: FlattenRoute[], currentUrl: string) => {
	const currentPath = getPathFromUrl(currentUrl);

	return routes.find((route) => {
		const routePath = getPathFromUrl(route.path);
		return routePath === currentPath;
	});
};

export const handleLanguageSwitcherItems = (
	flattenRoutes: FlattenRoute[],
	isMobile: boolean,
) => {
	const languageSwitcher = isMobile
		? document.getElementById('language-list-lg')
		: document.getElementById('language-list');

	if (!languageSwitcher) return;

	const currentUrl = window.location.href;
	const matchedRoute = findExactPathMatch(flattenRoutes, currentUrl);

	if (!matchedRoute?.languages?.length) {
		console.error('No language links available for this route');
		return;
	}

	const languageLinks: HTMLAnchorElement[] = Array.from(
		languageSwitcher.querySelectorAll('li > a'),
	);

	if (!languageLinks || languageLinks.length === 0) {
		console.error('No language links found in the DOM');
		return;
	}

	languageLinks.forEach((link) => {
		const linkElement = link;
		const linkElementParent = linkElement.parentElement;

		if (!linkElementParent) return;

		const matchedLanguage = matchedRoute?.languages.find((language) =>
			linkElement.title.includes(language.LanguageName),
		);

		if (matchedLanguage) {
			linkElement.href = matchedLanguage.LanguageUrl;
			linkElement.parentElement.style.display = 'block';
		} else {
			linkElement.parentElement.style.display = 'none';
		}
	});
};
